export const LEVEL_META = {
  beginner: {
    label: "AI Security Analyst", color: "emerald", dot: "bg-emerald-500",
    chip: "bg-emerald-50 text-emerald-700 border-emerald-200",
    accent: "#00E5FF",
    chipDark: "bg-[#00E5FF]/10 text-[#00E5FF] border border-[#00E5FF]/30",
    chipThemed: "bg-emerald-50 text-emerald-700 border border-emerald-200 dark:bg-[#00E5FF]/10 dark:text-[#00E5FF] dark:border-[#00E5FF]/30",
    dotDark: "bg-[#00E5FF]",
  },
  intermediate: {
    label: "AI Red Teamer", color: "amber", dot: "bg-amber-500",
    chip: "bg-amber-50 text-amber-700 border-amber-200",
    accent: "#FFB020",
    chipDark: "bg-amber-400/10 text-amber-300 border border-amber-400/30",
    chipThemed: "bg-amber-50 text-amber-700 border border-amber-200 dark:bg-amber-400/10 dark:text-amber-300 dark:border-amber-400/30",
    dotDark: "bg-amber-400",
  },
  advanced: {
    label: "AI Red Team Operator", color: "rose", dot: "bg-rose-500",
    chip: "bg-rose-50 text-rose-700 border-rose-200",
    accent: "#FF3B30",
    chipDark: "bg-[#FF3B30]/10 text-[#FF3B30] border border-[#FF3B30]/30",
    chipThemed: "bg-rose-50 text-rose-700 border border-rose-200 dark:bg-[#FF3B30]/10 dark:text-[#FF3B30] dark:border-[#FF3B30]/30",
    dotDark: "bg-[#FF3B30]",
  },
  developer: {
    label: "AI AppSec Engineer", color: "indigo", dot: "bg-indigo-500",
    chip: "bg-indigo-50 text-indigo-700 border-indigo-200",
    accent: "#818CF8",
    chipDark: "bg-indigo-400/10 text-indigo-300 border border-indigo-400/30",
    chipThemed: "bg-indigo-50 text-indigo-700 border border-indigo-200 dark:bg-indigo-400/10 dark:text-indigo-300 dark:border-indigo-400/30",
    dotDark: "bg-indigo-400",
  },
  supplychain: {
    label: "AI Supply Chain Security", color: "lime", dot: "bg-lime-500",
    chip: "bg-lime-50 text-lime-700 border-lime-200",
    accent: "#84CC16",
    chipDark: "bg-lime-400/10 text-lime-300 border border-lime-400/30",
    chipThemed: "bg-lime-50 text-lime-700 border border-lime-200 dark:bg-lime-400/10 dark:text-lime-300 dark:border-lime-400/30",
    dotDark: "bg-lime-400",
  },
  infra: {
    label: "AI Infrastructure Security", color: "orange", dot: "bg-orange-500",
    chip: "bg-orange-50 text-orange-700 border-orange-200",
    accent: "#F97316",
    chipDark: "bg-orange-400/10 text-orange-300 border border-orange-400/30",
    chipThemed: "bg-orange-50 text-orange-700 border border-orange-200 dark:bg-orange-400/10 dark:text-orange-300 dark:border-orange-400/30",
    dotDark: "bg-orange-400",
  },
  claudecode101: {
    label: "Claude Code 101", color: "sky", dot: "bg-sky-500",
    chip: "bg-sky-50 text-sky-700 border-sky-200",
    accent: "#0EA5E9",
    chipDark: "bg-sky-400/10 text-sky-300 border border-sky-400/30",
    chipThemed: "bg-sky-50 text-sky-700 border border-sky-200 dark:bg-sky-400/10 dark:text-sky-300 dark:border-sky-400/30",
    dotDark: "bg-sky-400",
  },
};

// Full role/track names (used for track headers, certificates, verify page).
export const LEVEL_LABEL = {
  beginner: "AI Security Analyst",
  intermediate: "AI Red Teamer",
  advanced: "AI Red Team Operator",
  developer: "AI Application Security Engineer",
  supplychain: "AI Supply Chain Security",
  infra: "AI Infrastructure Security",
  claudecode101: "Claude Code 101",
};

export const STATUS_META = {
  not_started: {
    label: "Not started", chip: "bg-slate-100 text-slate-600 border-slate-200",
    chipDark: "bg-white/5 text-zinc-400 border border-white/10",
    chipThemed: "bg-zinc-100 text-zinc-600 border border-zinc-200 dark:bg-white/5 dark:text-zinc-400 dark:border-white/10",
  },
  in_progress: {
    label: "In progress", chip: "bg-blue-50 text-blue-700 border-blue-200",
    chipDark: "bg-[#00E5FF]/10 text-[#00E5FF] border border-[#00E5FF]/30",
    chipThemed: "bg-blue-50 text-blue-700 border border-blue-200 dark:bg-[#00E5FF]/10 dark:text-[#00E5FF] dark:border-[#00E5FF]/30",
  },
  completed: {
    label: "Completed", chip: "bg-emerald-50 text-emerald-700 border-emerald-200",
    chipDark: "bg-emerald-400/10 text-emerald-300 border border-emerald-400/30",
    chipThemed: "bg-emerald-50 text-emerald-700 border border-emerald-200 dark:bg-emerald-400/10 dark:text-emerald-300 dark:border-emerald-400/30",
  },
  skipped: {
    label: "Skipped", chip: "bg-slate-100 text-slate-600 border-slate-200",
    chipDark: "bg-white/5 text-zinc-400 border border-white/10",
    chipThemed: "bg-zinc-100 text-zinc-600 border border-zinc-200 dark:bg-white/5 dark:text-zinc-400 dark:border-white/10",
  },
};
